import { render, staticRenderFns } from "./UniversalSelectorWithoutTag.vue?vue&type=template&id=e4a3c274&scoped=true&"
import script from "./UniversalSelectorWithoutTag.vue?vue&type=script&lang=js&"
export * from "./UniversalSelectorWithoutTag.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSelectorWithoutTag.vue?vue&type=style&index=0&id=e4a3c274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a3c274",
  null
  
)

export default component.exports